<a [matTooltip]="tooltip" class="tile-link">
  <div
    [routerLink]="tileUseString !== 'tile-disabled' ? path : null"
    [ngClass]="'tile ' + tileUseString"
  >
    <div class="tile-icon">
      <mat-icon [inline]="true" class="material-icons-outlined">{{
        icon
      }}</mat-icon>
    </div>
    <div class="tile-label">{{ label }}</div>
  </div>
</a>
